class DealerModel {
  constructor(obj) {
    this.id = null;
    this.title = null;
    this.created_at = null;
    this.updated_at = null;
    this.deleted_at = null;
    this.id_external = null;
    this.zip_code = null;
    this.email = null;
    this.latitude = null;
    this.longitude = null;
    this.site_url = null;
    this.img_url = null;
    this.email_test_drive = null;
    this.email_service_contract = null;
    this.email_maintenance = null;
    this.email_carcase_repair = null;
    this.comment = null;
    this.ignore_sync = true;

    this.source = {
      id: 'manual',
    };
    this.city = null;
    this.status = null;

    this.address = [];
    this.phones = [];
    this.faxes = [];

    if (obj) {
      Object.assign(this, obj);
    }
  }

  get dto() {
    return {
      ...this,
      city_id: this.city ? this.city.id : null,
      source_id: this.source ? this.source.id : null,
      status_id: this.status ? this.status.id : null,
    };
  }
}

export default DealerModel;
